// ──────────────────────────────────────────────────────────────────────────
// GIOCO IO
//
// Quando il maestro gioca lui — una partita, un allenamento suo — il campo
// lo prenota e lo paga lui: segnarlo qui vuol dire vederlo in agenda
// accanto alle lezioni, averlo su Google Calendar e ritrovarsi a fine mese
// quanto ha speso di campi per giocare.
//
// Si chiama "Gioco io" e non "Partita" perché quello che deve passare è chi
// gioca: una partita può essere anche quella dei tuoi allievi. Nel codice
// resta `partita`, e i nomi qui sotto parlano di partite.
//
// Si salva come una lezione — orario, campo, luce, riscaldamento, note,
// ripetizione, evento sul calendario: c'è già tutto — con un tipo di lezione
// suo, `partita`. Non sta nel catalogo, perché non è una cosa che si insegna
// né che si prezza: la conosce l'app, e la aggiunge ai tipi che conosce
// (`withMatchLessonType`). Il listino legge il catalogo crudo, quindi lì non
// compare. Si comincia dal "+", che chiede "Lezione o Gioco io?"
// (NewLessonMenu); nel profilo lo si spegne (MatchesSelector).
//
// Non è lavoro: non ha allievi, non ha incassi, non si fattura e non entra
// nelle ore di lezione. In agenda è una riga compatta (MatchRow), come le
// lezioni degli altri circoli. Del campo invece si sa quanto costa, e il
// riepilogo lo dice in una riga a parte, fuori dal netto: è una spesa tua,
// non del lavoro.
// ──────────────────────────────────────────────────────────────────────────
export const MATCH_LESSON_TYPE = "partita"

export const MATCH_LESSON_TYPE_DATA = {
	lessonTypeName: "Gioco io",
	lessonTypeDescription: "quando giochi tu: il campo lo paghi tu",
	minimumPlayers: 0,
	maxPlayers: 0,
	needsPlayers: false,
	needsCourt: true,
	// una partita, a tennis come a padel, è un'ora e mezza di campo
	defaultDuration: 1.5,
	color: "match",
	namesCanWait: false,
	allowsAssistants: false,
}

export const isMatchLessonType = lessonTypeID => lessonTypeID === MATCH_LESSON_TYPE

export const isMatch = lesson => isMatchLessonType(lesson?.lessonType)

// I tipi di lezione che si conoscono, più la partita. Sta in fondo: un
// documento che si chiamasse così non può farle cambiare comportamento.
export const withMatchLessonType = lessonTypes => ({
	...lessonTypes,
	[MATCH_LESSON_TYPE]: MATCH_LESSON_TYPE_DATA,
})

// Le lezioni, senza le partite: quelle che si contano come lavoro.
export const withoutMatches = lessons => (lessons ?? []).filter(lesson => !isMatch(lesson))
